/* DO NOT DELETE COMMENTED CODE */

// const desktopNavMenuItems = document.querySelectorAll(".navbar-one__desktop .navbar-one__menu .menu-item-has-children > a");

// const toggleDesktopMenuItem = (itemLink) => {
//   const item = itemLink.closest(".menu-item-has-children");

//   desktopNavMenuItems.forEach((otherItemLink) => {
//     const otherItem = otherItemLink.closest(".menu-item-has-children");

//     if (otherItem !== item) {
//       otherItem.classList.remove("open");
//     }
//   });

//   item.classList.toggle("open");
// };

// desktopNavMenuItems.forEach((item) => {
//   item.addEventListener("click", (e) => {
//     e.preventDefault();
//     toggleDesktopMenuItem(item);
//   });
// });

// close mega menu if clicked outside while open
const closeMegaMenu = () => {
  const masthead = document.querySelector("#masthead");
  if (masthead) {
    document.addEventListener("click", (e) => {
      if (!masthead.contains(e.target)) {
        masthead.classList.remove("mega-menu-open");

        const menuItemsWithChildren = masthead.querySelectorAll(
          ".menu-item-has-children"
        );
        const subMenuItemsWithChildren = masthead.querySelectorAll(
          ".sub-menu-item-has-children"
        );

        const activeMenuItems = masthead.querySelectorAll(
          ".inner-nav-link"
        );

        menuItemsWithChildren.forEach((item) => {
          item.classList.remove("open");
        });

        subMenuItemsWithChildren.forEach((item) => {
          item.classList.remove("open");
        });

        activeMenuItems.forEach((item) => {
          item.classList.remove("active");
        });

        const megaMenuOneDropdowns = masthead.querySelectorAll(".mega-menu-one");
        const subMegaMenuOneDropdowns = masthead.querySelectorAll(
          ".mega-menu-one__sub-item-list"
        );

        megaMenuOneDropdowns.forEach((dropdown) => {
          dropdown.setAttribute("data-open", "false");
        });

        subMegaMenuOneDropdowns.forEach((dropdown) => {
          dropdown.setAttribute("data-open", "false");
        });
      }
    });
  }
};

if (document.readyState !== "loading") {
  closeMegaMenu();
} else {
  document.addEventListener("DOMContentLoaded", closeMegaMenu);
}
